import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { Icon } from './icons';

interface PublicLinkModalProps {
    show: boolean;
    onHide: () => void;
}

const PublicLinkModal: React.FC<PublicLinkModalProps> = ({ show, onHide }) => {
    const [secret, setSecret] = useState<string | null>(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (show) {
            setCopied(false);
            fetchSecret();
        }
    }, [show]);

    const fetchSecret = () => {
        axios.get<string>('/api/settings/public-secret')
            .then(response => setSecret(response.data))
            .catch(console.error);
    };

    const generateSecret = () => {
        if (secret && !window.confirm('Poprzedni link przestanie działać. Czy na pewno wygenerować nowy?')) {
            return;
        }
        axios.post<string>('/api/settings/public-secret/generate')
            .then(response => {
                setSecret(response.data);
                setCopied(false);
            })
            .catch(console.error);
    };

    const publicUrl = secret ? `${window.location.origin}/public/${secret}` : '';

    const copyToClipboard = () => {
        if (publicUrl) {
            navigator.clipboard.writeText(publicUrl)
                .then(() => {
                    setCopied(true);
                    setTimeout(() => setCopied(false), 2500);
                })
                .catch(console.error);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Publiczny link</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Każdy, kto ma ten link, może tylko <strong>odczytać</strong> podsumowanie płatności — bez podglądu szczegółów transakcji. Nie trzeba się logować.</p>
                {secret ? (
                    <>
                        <Form.Label htmlFor="public-link-url">Adres do udostępnienia</Form.Label>
                        <div className="copy-row mb-2">
                            <Form.Control id="public-link-url" value={publicUrl} readOnly onFocus={e => e.target.select()} />
                            <Button variant={copied ? 'success' : 'primary'} onClick={copyToClipboard} style={{ minWidth: 120 }}>
                                <Icon name={copied ? 'check' : 'copy'} size={16} />
                                {copied ? 'Skopiowano' : 'Kopiuj'}
                            </Button>
                        </div>
                    </>
                ) : (
                    <p className="text-muted">Brak wygenerowanego linku.</p>
                )}
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
                <span className="small text-muted">{secret ? 'Nowy link unieważnia poprzedni.' : ''}</span>
                <Button variant={secret ? 'outline-danger' : 'primary'} onClick={generateSecret}>
                    {secret ? 'Wygeneruj nowy link' : 'Wygeneruj link publiczny'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PublicLinkModal;
